export const IS_LOADING_TRUE = 'IS_LOADING_TRUE';
export const IS_LOADING_FALSE = 'IS_LOADING_FALSE';
export const IS_LOADING_GLOBAL_TRUE = 'IS_LOADING_GLOBAL_TRUE';
export const IS_LOADING_GLOBAL_FALSE = 'IS_LOADING_GLOBAL_FALSE';